import { createTheme } from "@mui/material/styles";
import { MobergFontFamily } from "../Components/MobergFont/MobergFont";
const baseStyles = {
    border: '1px solid var(--color-table-border)',
    "& .MuiDataGrid-withBorderColor:not(.MuiDataGrid-root)": {
        border: "none"
    },
    "& .MuiDataGrid-columnHeaders": {
        borderBottom: "none",
        borderTop: "none",
        paddingBottom: "20px",
    },
    "& .MuiDataGrid-filler": {
        backgroundColor: "var(--color-table-cell-bg)",
    },
    "& .MuiDataGrid-scrollbarFiller": {
        backgroundColor: "var(--color-table-header-bg)",
    },
    "& .MuiDataGrid-columnHeader": {
        fontSize: "17px",
        backgroundColor: 'var(--color-table-header-bg)',
        "&:focus": {
            outline: "none",
        },
        "& .MuiDataGrid-columnHeaderTitle": {
            fontWeight: "bold",
            color: "black",
            fontFamily: MobergFontFamily.REGULAR
        },
        "&:hover": {
            "& .MuiDataGrid-columnHeaderTitle": {
                opacity: 0.7
            }
        }
    },
    '& .MuiDataGrid-columnsContainer': {
        marginBottom: '20px',
    },
    "& .MuiDataGrid-cell": {
        color: "#293241",
        background: 'white',
        fontFamily: MobergFontFamily.REGULAR,
        userSelect: 'auto',
        "&:focus": {
            outline: "none",
        },
        borderRight: "1px solid var(--color-table-border)",
        fontSize: '15px'
    },
    "& .MuiDataGrid-cellCheckbox:focus-within": {
        outline: "none",
    },
    "& .MuiDataGrid-cell--withRenderer:focus-within": {
        outline: "none",
    },
    "& .MuiDataGrid-cell:focus": {
        outline: "none"
    },
    "& .MuiDataGrid-columnHeader:focus": {
        outline: 'none'
    },
    "& .MuiDataGrid-toolbarContainer": {
        justifyContent: "space-between",
        marginBottom: '0px',
        paddingBottom: '30px',
        padding: "0px 0px 30px 0px",
        "& .MuiButtonBase-root": {
            background: 'transparent',
            border: '1px solid var(--color-accent-interactive)',
            color: 'var(--color-accent-interactive)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '4px 8px',
            fontFamily: MobergFontFamily.HEADER,
            fontWeight: 600,
            fontStyle: 'normal',
            lineHeight: '150%',
            borderRadius: '6px',
            "& .MuiButton-startIcon": {
                display: 'none'
            }
        },
    },
    "& .MuiDataGrid-cellContent": {
        userSelect: 'text'
    },
    "& .MuiDataGrid-iconSeparator": {
        display: 'none'
    },
    "& .MuiDataGrid-virtualScroller": {
        '&::-webkit-scrollbar': {
            width: '1px', // Adjust the scrollbar width as needed	
            display: 'block',
            color: '#313a4a',
            borderRadius: '2px'
        },
        '&::-webkit-scrollbar-thumb': {
            background: 'gray', // Color of the scrollbar thumb	
            borderRadius: '6px', // Rounded corners of the thumb	
        },
        '&::-webkit-scrollbar-thumb:hover': {
            background: '#5F6267', // Color of the scrollbar thumb on hover	
        },
        '&::-webkit-scrollbar-track': {
            background: '#bec4cf',
            height: '1px',
            borderRadius: '2px'
        },
    },
    "& .MuiDataGrid-columnsPanelRow": {
        display: "none !important"
    },
    "& .MuiDataGrid-panel": {
        borderRadius: '6px'
    },
    "& .MuiDataGrid-footerContainer": {
        marginTop: '10px'
    },
    "& .progress-green": {
        background: '#D4EDDA !important'
    },
    "& .progress-red": {
        background: '#F8D7DA !important'
    },
    "& .progress-yellow": {
        background: '#FFFDD0 !important'
    }
}

const CustomTheme = createTheme({
    components: {
        MuiDataGrid: {
            styleOverrides: {
                root: ({ ownerState }) => {
                    // Allow opting out of custom styling for default MUI look
                    if (ownerState && ownerState.useDefaultMuiStyling) {
                        return {};
                    }
                    
                    if (ownerState && ownerState.density && ownerState.density === 'compact') {
                        return {
                            ...baseStyles,
                            "& .MuiDataGrid-columnHeader": {
                                borderTop: '1px solid var(--color-table-border)',
                                borderRight: '1px solid var(--color-table-border)',
                                borderBottom: '1px solid var(--color-table-border)',
                                background: 'var(--color-table-header-bg)',
                                fontSize: "17px",
                                cursor: 'pointer',
                                "&:focus": {
                                    outline: "none",
                                },
                                "& .MuiDataGrid-columnHeaderTitle": {
                                    fontWeight: "bold",
                                    color: "black",
                                    fontFamily: MobergFontFamily.HEADER
                                },
                                "&:hover": {
                                    "& .MuiDataGrid-columnHeaderTitle": {
                                        opacity: 0.7
                                    }
                                }
                            },
                            '& .MuiDataGrid-columnHeader:first-of-type': {
                                borderLeft: '1px solid var(--color-table-border)'
                            },
                            "& .MuiDataGrid-cell:first-of-type": {
                                borderLeft: '1px solid var(--color-table-border)',
                            },
                            '& .MuiDataGrid-row:last-of-type .MuiDataGrid-cell': {
                                borderBottom: "1px solid var(--color-table-border) !important",
                            },
                            "& .MuiDataGrid-row:nth-of-type(odd) .MuiDataGrid-cell": {
                                background: "var(--color-table-row-odd-bg)",
                            },
                            "& .MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-columnHeaderTitleContainer": {
                                display: "none"
                            }
                        }
                    } else {
                        return {
                            ...baseStyles,
                            "& .MuiDataGrid-columnHeader": {
                                paddingTop: '10px',
                                background: 'var(--color-table-header-bg)',
                                fontSize: "17px",
                                backgroundColor: 'var(--color-table-header-bg)',
                                cursor: 'pointer',
                                "&:focus": {
                                    outline: "none",
                                },
                                "& .MuiDataGrid-columnHeaderTitle": {
                                    fontWeight: "bold",
                                    color: "black",
                                    fontFamily: MobergFontFamily.HEADER
                                },
                                "&:hover": {
                                    "& .MuiDataGrid-columnHeaderTitle": {
                                        opacity: 0.7
                                    }
                                },
                            },
                            '& .MuiDataGrid-columnHeader:not(:last-of-type)': {
                                borderRight: '1px solid var(--color-table-border)'
                            },
                            "& .MuiDataGrid-cell": {
                                borderBottom: "1px solid var(--color-table-border)",
                                borderRight: "1px solid var(--color-table-border)",
                                background: 'var(--color-table-cell-bg)',
                                userSelect: 'auto',
                                color: "var(--color-table-cell-text)",
                                fontFamily: MobergFontFamily.REGULAR,
                                fontSize: '15px'
                            },
                            "& .MuiDataGrid-cell:last-child": {
                                borderRight: "none"
                            },
                            "& .MuiDataGrid-row:hover": {
                                background: "transparent !important",
                                backgroundColor: "transparent !important",
                                "& .MuiDataGrid-cell": {
                                    background: "transparent !important",
                                    backgroundColor: "transparent !important",
                                },
                            },
                            '& .MuiDataGrid-row:last-of-type .MuiDataGrid-cell': {
                                borderBottom: 'none',
                            },
                            '& .MuiDataGrid-row:first-of-type .MuiDataGrid-cell': {
                                borderTop: 'none',
                            },
                            "& .MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-columnHeaderTitleContainer": {
                                display: ownerState?.disableSelectAll ? 'none' : 'flex'
                            },
                            "& .MuiDataGrid-columnHeaderCheckbox": {
                                pointerEvents: ownerState?.disableSelectAll ? 'none' : 'auto'
                            }
                        }
                    }
                },
            }
        },
        MuiInput: {
            styleOverrides: {
                root: {
                    background: 'var(--color-input-bg)',
                    border: '1px solid var(--color-border-default)',
                    borderRadius: '3px',
                    flex: 1,
                    height: '34px',
                    transition: 'border 0.3s',
                    '&:has(.MuiInputBase-input:focus)': {
                        border: '1px solid var(--color-accent-interactive)'
                    },
                    '& .MuiInputAdornment-root': {
                        paddingLeft: '5px'
                    },
                    '& .MuiInputBase-input:focus': {
                        color: 'var(--text-color)'
                    },
                    '& .MuiInputBase-input:not(:focus)': {
                        color: 'var(--text-secondary-color)'
                    },
                }
            }
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    "& ::-webkit-outer-spin-button, & ::-webkit-inner-spin-button": {
                        WebkitAppearance: "none",
                        margin: 0,
                    },
                    "& [type=number]": {
                        MozAppearance: "textfield",
                    }
                }
            }
        },
        MuiTooltip: {
            styleOverrides: {
                popper: {
                    zIndex: 10000
                }
            }
        },
        MuiPopper: {
            styleOverrides: {
                root: {
                    zIndex: 10000
                }
            }
        },
        MuiModal: {
            styleOverrides: {
                root: {
                    zIndex: 10000
                }
            }
        }
    }
})

export default CustomTheme